import React, { Component } from "react";
import { IconButton, Icon, Button,List, ListItem,
 ListItemText, ListItemIcon, ListItemSecondaryAction,Card,Typography,
Dialog,DialogActions,DialogTitle} from "@material-ui/core";
import "date-fns";
import { connect } from "react-redux";
import * as actionCreators from '../../store/actions/index';
import RootRef from "@material-ui/core/RootRef";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import EditIcon from "@material-ui/icons/Edit";
import AddSource from "./AddSource"

// reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    result.map((value, index) => {
        result[index].order_no = index + 1;
    })
  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    background: "rgb(235,235,235)"
  })
});

const getListStyle = isDraggingOver => ({
  //background: isDraggingOver ? 'lightblue' : 'lightgrey',
});

class Sources extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sourcesList: [],
            openAddPop: false,
            FullLeadStatusDialog: false,
            minimizeLeadStatusDialog: false,
            isDeleteConfirmDialoOpen: false,
            deleteItemName: '',
            deleteData: '',
            sourceRecData: {},
        };
        this.onDragEnd = this.onDragEnd.bind(this);
    }
    
    handleLeadDialogClose = () => {
        this.setState({ openAddPop: false });
    };
    handleLeadDialogMinimize = () => {
        this.setState(oldStateminimizeLeadDialog => ({ minimizeLeadStatusDialog: !oldStateminimizeLeadDialog.minimizeLeadStatusDialog }));
        this.setState({FullLeadStatusDialog: false})
    };

    handleLeadDialogFull = () => {
        this.setState(oldStateFullCreateLeadDialog => ({ FullLeadStatusDialog: !oldStateFullCreateLeadDialog.FullLeadStatusDialog }));
        this.setState({minimizeLeadStatusDialog: false})

    };

    componentDidMount() {
        this.props.loadSources(this.props.apolloClient.client);
    }

    componentWillReceiveProps(props){
        if (props.settingReducer.sourcesList.data != null) {
            var dataList = props.settingReducer.sourcesList.data;
            dataList.sort(function(a,b){return a.order_no - b.order_no});
            this.setState({ sourcesList: dataList});
        }
    }

    onDragEnd(result) {
        if (!result.destination) {
          return;
        }

        const items = reorder(
          this.state.sourcesList,
          result.source.index,
          result.destination.index
        );

        this.setState({sourcesList : items});
        
        var idsArray = [];
        var sourceListOrder = [];
        items.map((value, index) => {
            idsArray.push(parseInt(value.id));
            sourceListOrder.push(value.order_no);
        })
        
        let req = {
            sourceIds:idsArray,
            sourceListOrder:sourceListOrder,
        }
        this.props.updateSourceListOrder(this.props.apolloClient.client,req);
        this.props.settingReducer.sourcesList.data = items;
    }

    handleAddUpdate = (data)=>{
        let info = {}
        if(data && data !=undefined){
            info.name = data.name
            info.id = data.id
            info.isEdit = true
        }else{
            info.isEdit = false
        }
        this.setState({openAddPop:false},()=>{
            this.setState({sourceRecData:info,openAddPop:true});
        });
    }

    handleDeleteSource = (data) => {
        this.setState({deleteItemName:data.name});
        this.toggleDeleteDialog(data)
    };

    toggleDeleteDialog = (data) => {
        this.setState({ isDeleteConfirmDialoOpen: !this.state.isDeleteConfirmDialoOpen,deleteData:data});
    };

    confirmDeleteSource = () => {
        let req = {
            sourceid:parseInt(this.state.deleteData.id),
        }
        this.props.deleteSource(this.props.apolloClient.client,req);
        this.toggleDeleteDialog()
    };

    findWithAttr = (array, attr, value) => {
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }

    handleChange = (event, source) => {
        console.log("source", source);
        console.log("event", event);
        event.persist();
        this.setState({
          [event.target.name]: event.target.value
        });
    };

    render() {
        return (
            <div>
                <Typography className="card-margin-leadstatus" variant="h5" color="inherit">Sources</Typography>
                <Typography className="card-margin-leadstatus"></Typography>
                <Card className="signup-card">
                    <div className="lead_upcoming">
                        <div className="box_portlet">
                            <div className="box_header">
                                <div className="box_label"><h3 className="box_title" style={{marginLeft: '65px'}}>Name</h3></div>
                                <div className="box_tools">
                                    <Button variant="contained" color="secondary" onClick={() => this.handleAddUpdate()} size="small" style={{ minWidth: 95 }}>
                                        Create Source
                                    </Button>
                                    {this.state.openAddPop && (
                                        <AddSource
                                            handleClose={this.handleLeadDialogClose}
                                            open={this.state.openAddPop}
                                            handleMinimize={this.handleLeadDialogMinimize}
                                            handleFull={this.handleLeadDialogFull}
                                            minimizeScreen={this.state.minimizeLeadStatusDialog}
                                            fullScreen={this.state.FullLeadStatusDialog}
                                            sourceRecData={this.state.sourceRecData}
                                        />
                                    )} 
                                </div>
                            </div>
                            <div className="box_body">
                                Create and customize Sources to track where Opportunities are coming from.
                                 <DragDropContext onDragEnd={this.onDragEnd}>
                                    <Droppable droppableId="droppable">
                                      {(provided, snapshot) => (
                                        <RootRef rootRef={provided.innerRef}>
                                          <List style={getListStyle(snapshot.isDraggingOver)}>
                                            {this.state.sourcesList && this.state.sourcesList.map((item, index) => (
                                              <Draggable key={item.id} draggableId={item.id} index={index}>
                                                {(provided, snapshot) => (
                                                    <ListItem
                                                        ContainerComponent="li"
                                                        ContainerProps={{ ref: provided.innerRef }}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                          snapshot.isDragging,
                                                          provided.draggableProps.style
                                                        )}
                                                      >
                                                    <ListItemIcon> <Icon>drag_handle</Icon> </ListItemIcon>
                                                    <ListItemText primary={item.name}/>
                                                    <ListItemSecondaryAction>
                                                      {item.is_allowto_edit && <IconButton onClick={()=>this.handleAddUpdate(item)} ><EditIcon/></IconButton>}
                                                      {item.is_allowto_delete && <IconButton onClick={()=>this.handleDeleteSource(item)}><Icon>delete</Icon></IconButton>}
                                                      {!item.is_allowto_delete && !item.is_allowto_edit && <IconButton><Icon>lock</Icon></IconButton>}
                                                      
                                                      
                                                    </ListItemSecondaryAction>
                                                  </ListItem>
                                                )}
                                              </Draggable>
                                            ))}
                                            {provided.placeholder}
                                          </List>
                                        </RootRef>
                                      )}
                                    </Droppable>
                                  </DragDropContext>
                            </div>
                            <Dialog
                                  fullWidth={true}
                                  maxWidth = {'xs'}
                                  open={this.state.isDeleteConfirmDialoOpen}
                                  onClose={this.toggleDeleteDialog}
                                  disableBackdropClick
                                  disableEscapeKeyDown
                                  aria-labelledby="ar-remove-dialog-title"
                                >
                                    <DialogTitle id="ar-remove-dialog-title">{"Are you sure to remove "} {this.state.deleteItemName} {"?"}</DialogTitle>
                                    <DialogActions>
                                      <Button  onClick={this.toggleDeleteDialog} color="primary">
                                          Cancel
                                      </Button>
                                      <Button  type="Button" onClick={() =>this.confirmDeleteSource()}  className="btn_Primary">
                                        Ok
                                      </Button>
                                       
                                    </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    settingReducer: state.settingReducer,
    apolloClient: state.apolloClient
});


const mapDispatchToProps = dispatch => {
    return {
        loadSources: (client) => dispatch(actionCreators.loadSources(client)),
        updateSourceListOrder: (client,req) => dispatch(actionCreators.updateSourceListOrder(client,req)),
        deleteSource: (client,req) => dispatch(actionCreators.deleteSource(client,req)),
    }
}

export default (connect(mapStateToProps, mapDispatchToProps)(Sources));
